const abortControllers = {}

const GraphQLRequest = async (url, query, variables, headers) => {
  try {
    let body
    if (query?.includes('{') || query?.includes('}')) {
      body = {
        query: query,
        variables: variables,
      }
    } else {
      body = {
        id: query,
        variables: variables,
      }
    }

    let signal = null
    try {
      if (typeof window !== 'undefined' && window.AbortController) {
        if (abortControllers[query]) {
          abortControllers[query].abort()
        }
        abortControllers[query] = new AbortController()
        signal = abortControllers[query].signal
      }
    } catch (error) {
      console.warn('AbortController not supported', error)
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body: JSON.stringify(body),
      credentials: 'include',
      signal: signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then((response) => {
        if (response.errors) {
          response.errors.forEach((x) => console.error(x))
        }
        return response.data
      })
      .catch((error) => {
        throw error
      })
  } catch (error) {
    if (error.name === 'AbortError') {
      return null
    }

    console.error('Failed GraphQL Request', error)
    return null
  }
}

export default GraphQLRequest
